import { Button } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { HomeSearchTrackingEventLocation } from '../../../../constants/tracking'
import history from '../../../../history'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import OverlayPanel from '../../../shared/Routing/OverlayPanel'
import AirDnaLearnMorePanel from '../../../shared/AirDna/AirDnaLearnMore/AirDnaLearnMorePanel'

export const MSG = defineMessages({
  title: {
    id: 'ShortTermRentalLearnMoreButton.title',
    defaultMessage: 'Short term rental potential'
  },
  learnMore: {
    id: 'ShortTermRentalLearnMoreButton.learnMore',
    defaultMessage: 'Learn more about short term rentals'
  }
})

export const ShortTermRentalLearnMoreButton = () => {
  const intl = useIntl()
  return (
    <>
      <OverlayPanel
        back={OVERLAY_HELPERS.airDnaLearnMore.getOrigin()}
        path={OVERLAY_HELPERS.airDnaLearnMore.buildPath()}
        title={intl.formatMessage(MSG.title)}
        component={AirDnaLearnMorePanel}
      />
      <Button
        colorScheme='secondary'
        width='100%'
        tracking={{
          guid: 'gqDj5KrY9S8YMYNBoSXY8u',
          descriptor: intl.formatMessage(MSG.learnMore),
          ui_context: HomeSearchTrackingEventLocation.HOME_SEARCH_LISTING_DETAILS_SHORT_TERM_RENTAL_LEARN_MORE_BUTTON
        }}
        onClick={() => history.push(OVERLAY_HELPERS.airDnaLearnMore.buildPath())}
      >
        {intl.formatMessage(MSG.learnMore)}
      </Button>
    </>
  )
}
